import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MaxDisallowedPositionsInOneGroupValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        if (stacking.isDisallowedPositionsUsed()) {
            if (this.isPositionsQuantityExceededForGroupNumber(1)) {
                this.addError('Too many positions in Primary Stack were chosen.');
            }
            if (this.isPositionsQuantityExceededForGroupNumber(2)) {
                this.addError('Too many positions in Second Stack were chosen.');
            }
        }
    }

    private isPositionsQuantityExceededForGroupNumber(groupNumber): boolean {
        // @ts-ignore
        const {sportConfig} = this.dependencies;
        const neededPositionsQuantity = this.getNeededPositionsQuantityForGroupNumber(groupNumber);
        const lineupPlayersQuantity = sportConfig.getPlayersInTeam();

        return lineupPlayersQuantity < neededPositionsQuantity;
    }

    private getNeededPositionsQuantityForGroupNumber(groupNumber): number {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const chosenPlayersQuantity = stacking.getPlayersQuantityByGroupNumber(groupNumber);
        const disallowedPositions = stacking.getDisallowedPositionsByGroupNumber(groupNumber);
        return disallowedPositions.length + chosenPlayersQuantity;
    }
}

export default MaxDisallowedPositionsInOneGroupValidator;
